import {
  ChangeDetectionStrategy,
  Component,
  Inject,
  OnInit,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { buildUserManageForm, UserManageForm } from './user-mange-modal.form';
import {
  UserManageDialogData,
  UserManageDialogResult,
} from '../../types/user-manage.types';

@Component({
  selector: 'app-user-mange-modal',
  templateUrl: './user-mange-modal.component.html',
  styleUrl: './user-mange-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserMangeModalComponent implements OnInit {
  form!: UserManageForm;

  constructor(
    private dialogRef: MatDialogRef<
      UserMangeModalComponent,
      UserManageDialogResult
    >,
    @Inject(MAT_DIALOG_DATA) public data: UserManageDialogData,
  ) {}

  ngOnInit(): void {
    const user = this.data.mode === 'edit' ? this.data.user : undefined;
    this.form = buildUserManageForm(user);
  }

  close() {
    this.dialogRef.close();
  }

  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }

    const v = this.form.getRawValue();

    const basePayload = {
      first_name: v.first_name.trim(),
      last_name: v.last_name.trim(),
      email: v.email.trim().toLowerCase(),
      tel_no: v.tel_no.trim(),
      role: v.role!,
      status: v.status!,
    };

    if (this.data.mode === 'create') {
      this.dialogRef.close(basePayload);
    } else {
      this.dialogRef.close({
        user_id: this.data.user.id,
        user_info: basePayload,
      });
    }
  }
}
